import React, {useEffect, useState} from 'react';
import {templatePropTypes} from "../constants"
import Logo from "./Logo"
import AdfoxFull from "./adblocks/AdfoxFull"
import NewsText from "./NewsText"
import SmiJs from "./SmiJs"
import BackClick from "./BackClick";
import Popup from "./Popup";
import NewsPreview from "./NewsPreview"
import SmiWidget from "../template2013/SmiWidget"
import BlurReload from "../utils/blurReload"
import {SideBar} from "./adblocks/SideBar"
import {ToPad} from "./adblocks/ToPad"
import {Feed} from "./adblocks/Feed"
import {PopupModal} from "./adblocks/PopupModal";
import {Push} from "./adblocks/Push"


export default function Template2013Component({news, context}) {
    const [showModal, setShowModal] = useState(false);
    const showPopUp = context.pop_up !== undefined ? context.pop_up : true
    const showBackClick = context.back_click !== undefined ? context.back_click : true
    const url = new URL(window.location.href);
    const full = url.searchParams.get("full");
    const isFull = !!full
    const isDesktop = context.device === "desktop"
    let fprVersion;
    const fprParam = url.searchParams.get('fpr');
    if (fprParam) {
        fprVersion = fprParam.split('_')[1];
    }
    let sid = context.analytics_lable;

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowModal(true);
        }, 5000);

        return () => clearTimeout(timer);
    }, []);

    const closeModal = () => {
        setShowModal(false);
    };


    return (
        <div id="wrapper">
            {showBackClick && <BackClick/>}
            {showPopUp && <Popup/>}
            <Push isDesktop={isDesktop} isFull={isFull}/>
            <BlurReload url={`https://glavnoe.life/pages/lp2013/?subid=${sid}`} timeout="30000"/>
            <SmiJs context={context}/>
            <AdfoxFull context={context}/>
            {isDesktop && <PopupModal show={showModal} onClose={closeModal} isFull={isFull}/>}
            <div className="wrapper-holder">
                <header id="header" className="flex">
                    <strong className="logo">
                        <a href="#">
                            <Logo/>
                        </a>
                    </strong>
                </header>
                <main id="main">
                    <ToPad isDesktop={isDesktop} isFull={isFull}/>
                    <div className="main-holder flex">
                        <section id="content">
                            {isFull ? <NewsText news={news} context={context} isDesktop={isDesktop}/> :
                                <NewsPreview image={news.image} title={news.title} isDesktop={isDesktop}/>}
                        </section>
                        {isDesktop && <SideBar isFull={isFull}/>}
                    </div>
                    <Feed isDesktop={isDesktop} isFull={isFull}/>
                    <footer className="down"/>
                </main>
            </div>
        </div>
    );
}

Template2013Component.propTypes = templatePropTypes
